import { call, put, takeLatest } from 'redux-saga/effects';
import { Companies } from 'services/api';
import {
  adminCompany,
  adminCompanySuccess,
  adminCompanyFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* getAdminCompany({ payload }) {
  try {
    const { data } = yield call(Companies.adminCompany, payload);
    yield put(adminCompanySuccess(data));
  } catch (e) {
    yield put(adminCompanyFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(adminCompany, getAdminCompany);
